var _defs, _path, _path2, _rect, _rect2, _g, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 887.82,
    height: 625.36,
    viewBox: "0 0 887.82 625.36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "defaultImg_svg__a",
    x1: 600,
    y1: 754.02,
    x2: 600,
    y2: 145.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "defaultImg_svg__b",
    x1: 437.25,
    y1: 574.51,
    x2: 437.25,
    y2: 36.62,
    xlinkHref: "#defaultImg_svg__a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "defaultImg_svg__c",
    transform: "translate(-163.46 -145.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.65,
    y: 194.98,
    width: 767.31,
    height: 510.36,
    rx: 8.85,
    ry: 8.85,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1036 734.86a19.06 19.06 0 01-19 19.14H183a19.06 19.06 0 01-19-19.16v-569.7A19.06 19.06 0 01183 146h834a19.06 19.06 0 0119 19.16",
    transform: "translate(-163.46 -145.98)",
    fill: "url(#defaultImg_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M862.73 579.56a18.52 18.52 0 01-18.52 18.52H29.47a18.52 18.52 0 01-18.52-18.52V28.8a18.52 18.52 0 0118.52-18.52h814.74a18.52 18.52 0 0118.52 18.52",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.49,
    y: 36.62,
    width: 787.52,
    height: 537.89,
    rx: 8.85,
    ry: 8.85,
    fill: "url(#defaultImg_svg__b)",
    "data-name": "<Rectangle>"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.19,
    y: 49,
    width: 767.31,
    height: 510.36,
    rx: 8.85,
    ry: 8.85,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#defaultImg_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.54 554.68l214.21-245.47a42.64 42.64 0 0160.34-3.94l60 52.93a42.64 42.64 0 0055.65.67l183.32-154.12a42.64 42.64 0 0159 4l225 247.64a42.64 42.64 0 0110.91 24.9l8.68 97.69a42.64 42.64 0 01-42.48 46.42H42.65A42.64 42.64 0 01.02 584.02a42.64 42.64 0 0110.52-29.34z",
    fill: "#4592ff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.58,
    cy: 130.83,
    r: 47.52,
    fill: "#ff5252"
  })));
}

var MemoSvgDefaultImg = /*#__PURE__*/React.memo(SvgDefaultImg);
export default MemoSvgDefaultImg;